class LSGProductGrid extends HTMLElement {
  constructor() {
    super();

    // UX elements
    
    this.selectBox = this.querySelector(".js-select-box");
    this.selectPlaceholder = this.querySelector(".js-select-placeholder");
    this.selectButton = this.querySelector(".js-select-button");
    this.optionsList = this.querySelector(".js-select-options");
    this.options = this.querySelectorAll(".js-select-option");
    this.asideFiltersMenuTrigger = this.querySelectorAll(
      ".js-aside-filters-menu-trigger",
    );
    this.asideMenuFilters = this.querySelector(".js-aside-menu-filters");
    this.overlay = this.querySelector(".js-overlay");
    this.listTriggers = this.querySelectorAll(".js-filters-list-trigger");
    this.activeModalClassName = 'modal-active';
    this.activeClassName = "active";
    this.lockClass = "is-locked";

    // Filter elements
    this.filterCheckbox = this.querySelectorAll(".js-filter-checkbox");
    this.filterClearButton = this.querySelector(".js-filters-clear-button");
    this.filterApplyButton = this.querySelector(".js-filters-apply-button");
    this.filterGroups = this.querySelectorAll(".product-grid__filters-group");
    this.filterPills = this.querySelector(".js-filter-pills");
    this.asideTopTextCounter = this.querySelector(".js-aside-top-text-counter");
    this.loader = this.querySelector(".js-loader");
    this.currentFilters = new Map();
    this.sortByFilter = "sort_by";
    this.pageFilter = "page";
    this.filter = "filter";

    this.selling_plans = this.querySelector(".js-selling-plan");
    this.custom_select_wrappers = this.querySelectorAll('.js-custom-select-wrapper');
    this.quick_buy_btns = this.querySelectorAll(".js-quick-buy-btn");
    this.buybox_modal = this.querySelector(".js-buybox-modal");
    this.buybox_modal_overlay = this.querySelector('.js-buybox-modal-overlay');
    this.buybox_modal_close_btn = this.querySelector('.js-modal-buybox-close');
    this.scriptsDataset = [
      "product-form.js",
      "share.js",
      "pickup-availability.js",
      "quick-add.js",
      "product-modal.js",
      "media-gallery.js",
      "product-model.js"
    ];

    // Custom Dropdown
    this.selectBoxes = this.querySelectorAll('.js-custom-select-box');
    this.flickityGallery = null;
    this.flickityThumbs = null;
  }

  connectedCallback() {
    console.log("LSGProductGrid connected");

    this.initUX();
    this.initFilterLogic();
    this.applyFiltersFromURL();
    this.bindEvents();
    this.initCustomDropdown();
  }

  /**
   * Binds event listeners to the quick buy buttons
   */
  bindEvents() {
    this.quick_buy_btns.forEach((btn) => {
      btn.addEventListener("click", this.onQuickBuyClick.bind(this));
    });
  }



  /**
   * Handles the click event on the quick buy button
   * @param {Event} e The click event
   */
  onQuickBuyClick(e) {
    e.preventDefault();
    const url = e.target.getAttribute("data-pdp-url");
    
    this.fetchBuybox(url, e.target.closest('.card-wrapper'));
  }

  /**
   * Fetches the buybox DOM from the given URL
   * 
   * @param {string} url The URL to fetch the buybox data from
   */
  fetchBuybox(url, productWrapper) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const buybox = doc.querySelector(".product-section");
        const evalScripts = doc.querySelectorAll('script.js-subscription-script');
        const newModal = document.createElement('div');

        // Render buybox modal
        newModal.classList.add('js-buybox-modal', 'product-grid__modal-content');
        newModal.innerHTML = buybox.innerHTML;
        this.buybox_modal.replaceWith(newModal);
        this.buybox_modal = newModal;

        // Initialize scripts
        doc.querySelectorAll('script').forEach(script => {
          const scriptExists = this.scriptsDataset.some(scriptData => script.src.includes(scriptData));
          // Render scripts with src
          if (scriptExists) {
            const newScript = document.createElement('script');
            newScript.src = script.src;
            document.body.appendChild(newScript);
          }

          // Render datasets
          if (script.type === 'application/json') {
            const newScript = document.createElement('script');
            newScript.type = 'application/json';
            newScript.innerHTML = script.innerHTML;
            document.body.appendChild(newScript);
          }
        });

        // Initialize scripts
        this.initReadMore();
 
        this.initBuyboxScript();

        // Init Flickity
        
        const galleryContainer = document.querySelectorAll('.product-modal__gallery-container');
        const thumbsContainer = document.querySelectorAll('.product-modal__thumbs-container');
        for (let i = 0; i < galleryContainer.length; i++) {
          setTimeout(() => {       
            this.initFlickity(galleryContainer[i], thumbsContainer[i]);
          }, 1000);
        }

        // Disable modal opener if there is only one slide
        // const mediaList = newModal.querySelectorAll('.product__media-list li');
        // if (mediaList.length <= 1) {
        //   newModal.querySelector('modal-opener').style.pointerEvents = 'none';
        //   newModal.querySelector('modal-opener').querySelector('.product__media-icon').style.display = 'none';
        // }

        // Render reviews
         const buyboxReview = this.buybox_modal.querySelector('reviewsio-product-ratings')
         if(buyboxReview) {
           buyboxReview.innerHTML = productWrapper.querySelector('.reviewsio--rating-snippet').innerHTML;
         }

        // Open modal
        this.buybox_modal_overlay.classList.add(this.activeModalClassName);
        document.body.classList.add(this.lockClass);

        // Close modal

        this.buybox_modal_close_btn.addEventListener('click', () =>{
          this.buybox_modal_overlay.classList.remove(this.activeModalClassName);
          document.body.classList.remove(this.lockClass);
        })
   
        const buyboxModalContentWrapper = this.buybox_modal_overlay.querySelector('.product-grid__modal-wrapper');
        this.buybox_modal_overlay.addEventListener('click', (event) =>{
         if(!buyboxModalContentWrapper.contains(event.target)) {
            this.buybox_modal_overlay.classList.remove(this.activeModalClassName);
          document.body.classList.remove(this.lockClass);
          }
   
        })

        // Evaluate scripts
        evalScripts.forEach(script => {
          eval(script.innerHTML);
        });
      });
  }


  initFlickity(galleryContainer, thumbsContainer) {
    const parentElement = galleryContainer.closest('.product-modal__content-inner');
    if (!galleryContainer || !thumbsContainer) {
        console.warn("One or both elements '.product-modal__gallery-container' or '.product-modal__thumbs-container' are not found.");
        return;
    }
    if (this.flickityGallery) {
        this.flickityGallery.destroy();
    }
    if (this.flickityThumbs) {
        this.flickityThumbs.destroy();
    }
    
    this.flickityGallery = new Flickity(galleryContainer, {
        cellAlign: 'center',
        contain: true,
        wrapAround: false,
        groupCells: 1,
        pageDots: false,
        prevNextButtons: true,
    });

    this.flickityThumbs = new Flickity(thumbsContainer, {
      contain: true,
      wrapAround: false,
      groupCells: 5,
      pageDots: false,
      prevNextButtons: false,
      asNavFor: galleryContainer,
      draggable: true, 
      freeScroll: true, 
      selectedAttraction: 0.01,
      friction: 0.15
    });

    this.flickityGallery.on('change', updatelsgModalGallerySliderCounter.bind(this));
    this.flickityThumbs.on('change', updatelsgModalGallerySliderCounter.bind(this));

    function updatelsgModalGallerySliderCounter() {
        const currentModalIndex = this.flickityGallery.selectedIndex + 1;
        const totalModalSlides = this.flickityGallery.slides.length;
        const buyboxSliderCounter = parentElement.querySelector('.product-modal__content-counter')
        if(buyboxSliderCounter){
          buyboxSliderCounter.textContent = `${currentModalIndex}/${totalModalSlides}`;
        }
    }

    updatelsgModalGallerySliderCounter.bind(this)();
  }

  /**
   * Initialize UX functionality (e.g., select dropdown handling)
   */
  initUX() {
    if (
      this.selectBox &&
      this.selectPlaceholder &&
      this.optionsList &&
      this.options.length > 0
    ) {
      this.handleSelectDropdown();
    }

    this.handleAssideFiltersMenu();

    this.handleClearApplyEvent();
    this.handleClearButtonEvent();
  }

  /**
   * Initialize filtering logic for the product grid
   */
  initFilterLogic() {
    this.filterCheckbox.forEach((checkbox) => {
      checkbox.addEventListener("change", (e) => {
        this.handleFilter(e);
      });
    });
  }

  /**
   * Handles the opening and closing of the select dropdown and selection of options
   */
  handleSelectDropdown() {
    this.selectBox.addEventListener("click", (e) => {
      e.stopPropagation();
      this.optionsList.classList.toggle(this.activeClassName);
      this.selectButton.classList.toggle(this.activeClassName);
    });

    this.options.forEach((option) => {
      option.addEventListener("click", (e) => {
        e.stopPropagation();
        const selectedValue = e.currentTarget.getAttribute("data-value");
        this.selectPlaceholder.textContent = selectedValue;
        this.handleCloseSelectDropDown();
        this.options.forEach((opt) =>
          opt.classList.remove(this.activeClassName),
        );
        e.currentTarget.classList.add(this.activeClassName);
      });
    });

    document.addEventListener("click", (e) => {
      if (!this.selectBox.contains(e.target)) this.handleCloseSelectDropDown();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.handleCloseSelectDropDown();
    });
  }

  handleCloseSelectDropDown() {
    this.optionsList.classList.remove(this.activeClassName);
    this.selectButton.classList.remove(this.activeClassName);
  }

  /**
   * Handles the opening aside filters menu
   */
  handleAssideFiltersMenu() {
    this.asideFiltersMenuTrigger.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        this.asideMenuFilters.classList.contains(this.activeClassName)
          ? this.handleCloseAsideFiltersMenu()
          : this.handleOpenAsideFiltersMenu();
      });
    });

    this.overlay.addEventListener(
      "click",
      this.handleCloseAsideFiltersMenu.bind(this),
    );

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.handleCloseAsideFiltersMenu();
    });

    this.listTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        const parentNode = e.currentTarget.parentNode;
        parentNode.classList.toggle(this.activeClassName);
      });
    });
  }

  handleCloseAsideFiltersMenu() {
    this.asideMenuFilters.classList.remove(this.activeClassName);
    this.overlay.classList.remove(this.activeClassName);
    this.removeLock();
  }

  handleOpenAsideFiltersMenu() {
    this.asideMenuFilters.classList.add(this.activeClassName);
    this.overlay.classList.add(this.activeClassName);
    this.addLock();
  }

  /**
   * Handle add  lock screen overlay
   */
  addLock() {
    document.documentElement.classList.add(this.lockClass);
    document.body.classList.add(this.lockClass);
  }

  /**
   * Handle remove lock screen overlay
   */
  removeLock() {
    document.documentElement.classList.remove(this.lockClass);
    document.body.classList.remove(this.lockClass);
  }

  /**
   * Handle apply button event
   */
  handleClearApplyEvent() {
    this.filterApplyButton.addEventListener("click", () => {
      const url = new URL(window.location.href);
      if (this.currentFilters.has(this.pageFilter)) {
        url.searchParams.set(this.pageFilter, "1");
        this.currentFilters.set(this.pageFilter, "1");
      }

      this.updateHistory(url);
      this.updateProducts();
      this.addFilterPills();
      this.handleCloseAsideFiltersMenu();
    });
  }

  /**
   * Handle clear button event
   */
  handleClearButtonEvent() {
    this.filterClearButton.addEventListener("click", () => {
      const url = new URL(window.location.href);

      this.currentFilters = new Map(
        [...this.currentFilters].filter(([key]) => !key.includes(this.filter)),
      );

      [...url.searchParams.keys()].forEach((key) => {
        if (key.includes(this.filter)) {
          url.searchParams.delete(key);
        }
      });

      this.filterCheckbox.forEach((e) => {
        if (e.getAttribute("data-filter-by") != this.sortByFilter)
          e.checked = false;
      });

      this.updateHistory(url);
      this.updateProducts();
      this.removeAllFilterPills();
      this.updateSelectedFiltersLength();
      this.handleCloseAsideFiltersMenu();
      this.getCheckedFilterCount();
    });
  }

  removeAllFilterPills() {
    this.querySelectorAll(".product-grid__filter-pill").forEach((e) => {
      e.remove();
    });
  }

  removeFilterPill() {
    this.querySelectorAll(".js-filter-pill-remove-btn").forEach((button) => {
      button.addEventListener("click", (e) => {
        const filterValue = e.currentTarget.getAttribute("data-filter");
        const filterBy = e.currentTarget.getAttribute("data-filter-by");

        const checkbox = Array.from(this.filterCheckbox).find((checkbox) => {
          return (
            checkbox.getAttribute("data-filter") === filterValue &&
            checkbox.getAttribute("data-filter-by") === filterBy
          );
        });

        if (checkbox) {
          checkbox.checked = false;
          this.handleFilter(e);
          this.updateProducts();
          e.currentTarget.parentNode.remove();
        }
      });
    });
  }

  updateSelectedFiltersLength() {
    this.filterGroups.forEach((group) => {
      const filtersTag = group.querySelector(".js-filter-tag");
      const filtersLength = filtersTag.querySelector(".js-filters-length");
      const filterBy = filtersTag.getAttribute("data-filter-by");
      const checkedFilters = group.querySelectorAll(
        `input[type="checkbox"][data-filter-by="${filterBy}"]:checked`,
      );
      const checkedCount = checkedFilters.length;

      filtersLength.textContent = `(${checkedCount})`;

      if (checkedCount === 0) {
        filtersLength.style.display = "none";
      } else {
        filtersLength.style.display = "";
      }
    });
  }

  addFilterPills() {
    this.removeAllFilterPills();
    this.filterCheckbox.forEach((checkbox) => {
      if (checkbox.checked) {
        const filterBy = checkbox.getAttribute("data-filter-by");
        const filterValue = checkbox.getAttribute("data-filter");
        const filterlabel = checkbox.getAttribute("data-filter-label");
        const unique = checkbox.getAttribute("data-unique");
        const multiCheckbox = checkbox.getAttribute("data-multi-checkbox");

        if (filterBy != this.sortByFilter) {
          let html = `
        <div class="product-grid__filter-pill">
          <span class="product-grid__pill-text js-filter-pill-text">${filterlabel}</span>
          <button class="product-grid__pill-remove-button js-filter-pill-remove-btn" data-filter="${filterValue}" data-filter-by="${filterBy}" data-multi-checkbox="${multiCheckbox ?? ""}" data-unique="${unique ?? ""}">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M9 9L1 1" stroke="#245A39" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M9 1L1 9" stroke="#245A39" stroke-miterlimit="10" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      `;
          this.filterPills.insertAdjacentHTML("beforeend", html);
        }
      }
    });
    this.removeFilterPill();
  }

  /**
   * Applies filters from the URL search params if any exist
   */
  applyFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    urlParams.forEach((value, key) => {
      if (!key.includes(this.filter)) {
        this.currentFilters.set(key, value);
      }
    });

    this.filterCheckbox.forEach((checkbox) => {
      const filterBy = checkbox.getAttribute("data-filter-by");
      const filterValue = checkbox.getAttribute("data-filter");
      const filteLabel = checkbox.getAttribute("data-filter-label");

      const multiCheckbox =
        checkbox.getAttribute("data-multi-checkbox") === "true";

      if (filterBy === this.sortByFilter) {
        if (
          urlParams.has(filterBy) &&
          urlParams.get(filterBy) === filterValue
        ) {
          checkbox.checked = true;
          this.selectPlaceholder.textContent = filteLabel;
        }
        return;
      }

      if (multiCheckbox) {
        const filterByParts = filterBy.split("&");
        const filterValueParts = filterValue.split("&");

        let allParamsMatch = true;

        // Check if all the filter parts match their respective values
        filterByParts.forEach((paramKey, index) => {
          const paramValue = urlParams.get(paramKey);
          if (paramValue !== filterValueParts[index]) {
            allParamsMatch = false;
          }
        });

        if (allParamsMatch) {
          checkbox.checked = true;

          // Adding filter values to currentFilters
          filterByParts.forEach((paramKey, index) => {
            const paramValue = filterValueParts[index];

            if (this.currentFilters.has(paramKey)) {
              const existingValue = this.currentFilters.get(paramKey);

              // If it's not an array, convert to an array
              if (!Array.isArray(existingValue)) {
                this.currentFilters.set(paramKey, [existingValue, paramValue]);
              } else if (!existingValue.includes(paramValue)) {
                // Add the new value if it's not already in the array
                existingValue.push(paramValue);
              }
            } else {
              // If no existing filter, initialize with an array
              this.currentFilters.set(paramKey, [paramValue]);
            }
          });
        }
      } else {
        // Handle single-value filters, but allow for multiple filterValues in URL
        if (urlParams.has(filterBy)) {
          const filterValues = urlParams.getAll(filterBy);

          if (filterValues.includes(filterValue)) {
            checkbox.checked = true;

            // Add all filter values into the currentFilters map
            if (this.currentFilters.has(filterBy)) {
              const existingValue = this.currentFilters.get(filterBy);

              // If it's not an array, convert to an array
              if (!Array.isArray(existingValue)) {
                this.currentFilters.set(filterBy, [
                  existingValue,
                  ...filterValues,
                ]);
              } else {
                filterValues.forEach((val) => {
                  if (!existingValue.includes(val)) {
                    existingValue.push(val); // Add only if not already present
                  }
                });
              }
            } else {
              // Initialize currentFilters with all filter values
              this.currentFilters.set(filterBy, filterValues);
            }
          }
        }
      }
    });
    this.addFilterPills();
    this.updateSelectedFiltersLength();
    this.getCheckedFilterCount();
  }

  /**
   * Handles filter checkbox changes
   */
  handleFilter(e) {
    const filter = e.currentTarget.getAttribute("data-filter");
    const filterBy = e.currentTarget.getAttribute("data-filter-by");
    const unique = Boolean(e.currentTarget.getAttribute("data-unique"));
    const multiCheckbox = Boolean(
      e.currentTarget.getAttribute("data-multi-checkbox"),
    );

    if (filterBy.includes("&") && multiCheckbox) {
      const filtersBy = filterBy.split("&");
      const filters = filter.split("&");

      filtersBy.forEach((filterBy, index) => {
        this.handleAddOrRemoveFilter(
          filters[index],
          filterBy,
          unique,
          e.currentTarget.checked,
        );
      });
    } else {
      this.handleAddOrRemoveFilter(
        filter,
        filterBy,
        unique,
        e.currentTarget.checked,
      );
    }
    this.updateSelectedFiltersLength();
  }

  /**
   * Add or remove a filter based on user input
   *
   * @param {string} filter The value of the filter being applied
   * @param {string} filterBy The category of the filter (e.g., 'sort_by')
   * @param {boolean} unique Whether this filter is unique or can coexist with others
   * @param {boolean} isChecked Whether the filter is being checked or unchecked
   */
  handleAddOrRemoveFilter(filter, filterBy, unique, isChecked) {
    this.handleFiltering(filter, filterBy, unique, isChecked);
    this.updateURL();
    this.getCheckedFilterCount();
    if (filterBy === this.sortByFilter) {
      this.updateProducts();
    }
  }

  /**
   * Handles standard filters like sorting or category selection
   *
   * @param {string} filter The value of the filter
   * @param {string} filterBy The key to filter by (e.g., 'sort_by')
   * @param {boolean} unique Whether this filter should be unique or not
   * @param {boolean} isChecked Whether the filter is being checked or unchecked
   */
  handleFiltering(filter, filterBy, unique, isChecked) {
    if (filterBy === this.sortByFilter) {
      // Handle sort filter separately
      this.currentFilters.set(this.sortByFilter, filter);
      this.filterCheckbox.forEach((checkbox) => {
        const checkboxFilterValue = checkbox.getAttribute("data-filter");
        const checkboxFilterBy = checkbox.getAttribute("data-filter-by");

        if (checkboxFilterBy === this.sortByFilter) {
          checkbox.checked = checkboxFilterValue === filter ?? false;
        }
      });
    } else {
      if (unique) {
        // If it's unique, first remove all other filters from the same group (filterBy)
        if (isChecked) {
          // Deselect other filters from the same group
          this.filterCheckbox.forEach((checkbox) => {
            const checkboxFilterBy = checkbox.getAttribute("data-filter-by");
            const checkboxFilterValue = checkbox.getAttribute("data-filter");

            if (checkboxFilterBy.includes("&")) {
              const filtersValue = checkboxFilterValue.split("&");
              if (filtersValue.some((f) => f === filter)) {
                checkbox.checked = true;
              } else {
                checkbox.checked = false;
              }
            }

            // Deselect filters from the same group if different
            if (
              checkboxFilterBy === filterBy &&
              checkboxFilterValue !== filter
            ) {
              checkbox.checked = false;
            }
          });

          this.currentFilters.set(filterBy, filter);
        } else {
          this.currentFilters.delete(filterBy);
        }
      } else {
        // Handle non-unique filters (multiple filters can coexist in the same group)
        if (isChecked) {
          if (this.currentFilters.has(filterBy)) {
            const existingFilters = this.currentFilters.get(filterBy);

            // Ensure that `existingFilters` is an array before adding to it
            if (!Array.isArray(existingFilters)) {
              this.currentFilters.set(filterBy, [existingFilters, filter]);
            } else {
              // Add filter only if it's not already present
              if (!existingFilters.includes(filter)) {
                this.currentFilters.set(filterBy, [...existingFilters, filter]);
              }
            }
          } else {
            this.currentFilters.set(filterBy, [filter]);
          }
        } else {
          // Remove filter from the array if unchecked
          const existingFilters = this.currentFilters.get(filterBy);
          if (Array.isArray(existingFilters)) {
            const updatedFilters = existingFilters.filter((f) => f !== filter);
            if (updatedFilters.length > 0) {
              this.currentFilters.set(filterBy, updatedFilters);
            } else {
              this.currentFilters.delete(filterBy); // Remove the key if no filters left
            }
          }
        }
      }
    }
  }

  getCheckedFilterCount() {
    const checkedFilters = Array.from(this.filterCheckbox).filter(checkbox => {
        return checkbox.checked && checkbox.getAttribute('data-filter-by').includes('filter');
    });

    if(this.asideTopTextCounter) {
      this.asideTopTextCounter.textContent =`(${checkedFilters.length})`;
    }
}

  /**
   * Updates the URL with the current filters
   */
  updateURL() {
    const url = new URL(window.location.href);

    // Step 1: Remove params from URL that are not present or don't match in currentFilters
    url.searchParams.forEach((value, key) => {
      if (key !== this.sortByFilter) {
        if (!this.currentFilters.has(key)) {
          // If key doesn't exist in currentFilters, delete it
          url.searchParams.delete(key);
        } else {
          const currentFilterValue = this.currentFilters.get(key);
          // If currentFilters value is an array, check if the value is in the array
          if (Array.isArray(currentFilterValue)) {
            if (!currentFilterValue.includes(value)) {
              url.searchParams.delete(key); // Delete param if it doesn't match
            }
          } else {
            // If the value in currentFilters doesn't match, delete it
            if (currentFilterValue !== value) {
              url.searchParams.delete(key);
            }
          }
        }
      }
    });

    // Step 2: Add or update params from currentFilters to URL
    this.currentFilters.forEach((value, key) => {
      if (Array.isArray(value)) {
        // Ensure all array values are added
        value.forEach((v) => {
          if (!url.searchParams.getAll(key).includes(v)) {
            url.searchParams.append(key, v);
          }
        });
      } else {
        // Set or update a single value
        url.searchParams.set(key, value);
      }
    });
    this.updateHistory(url);
  }

  /**
   * Updates the browser history with the new URL
   *
   * @param {URL} url The new URL with updated search parameters
   */
  updateHistory(url) {
    const newUrl = url.toString();
    window.history.pushState({ path: newUrl }, "", newUrl);
  }

  /**
   * Fetches updated product grid based on current filters and updates the DOM
   */
  updateProducts() {
    const targetElementProductGrid = this.querySelector(".js-product-grid-container");
    const targetElementPagination = this.querySelector(
      ".pagination-wrapper",
    );
    this.loader?.classList.add(this.activeClassName);
  
    fetch(window.location)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Fetch error: ${response.status} ${response.statusText}`);
        }
        return response.text();
      })
      .then((html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const newProductGrid = tempDiv.querySelector(".js-product-grid-container");
        const newPagination = tempDiv.querySelector(".pagination-wrapper");
  
        if (newProductGrid) {
          this.updateDOMElement(targetElementProductGrid, newProductGrid);
        }
        if (newPagination) {
          this.updateDOMElement(targetElementPagination, newPagination);
        }
      })
      .catch((error) => {
        console.error("Error updating products:", error);
      })
      .finally(() => {
        this.loader?.classList.remove(this.activeClassName);
      });
  }


  /**
   * Initializes the read more script
   */
  initReadMore() {
    const productDescription = document.querySelector('.js-product-description');
    const productReadMoreBtn = document.querySelector('.js-product-read-more');

    if (!productReadMoreBtn || !productDescription) {
        return '';
    }
    productReadMoreBtn.addEventListener('click', ()=>{
        productDescription.classList.toggle('expanded');

        if(productDescription.classList.contains('expanded')){
            productReadMoreBtn.textContent = 'Read Less';
        } else {
            productReadMoreBtn.textContent = 'Read More';
        }
    })
  }


  /**
   * Initializes the buybox script
   */
  initBuyboxScript() {
      const atcPrice = document.querySelector('.atc-price') 
      const tabs = document.querySelectorAll('.sr-variant-select-tab')
      const plans = document.querySelectorAll('.rtx-subscription-label')
      const savings = document.querySelector('#savings-amount')    

      tabs.forEach((tab) => {
        tab.addEventListener('click' , () => {
          setTimeout(() => {
            const active = document.querySelector('.rtx-subscription-label.is-selected')
            const activePrice = active.querySelector('.sr-full-price')
            const originalPrice = active.querySelector('.sr-compare-price') || activePrice
            const perServing = active.querySelector('.num-servings')
            const plan = document.querySelector('.rtx-subscription-label.is-selected')
            let totalServings = document.querySelector('.sr-variant-select-tab.is-selected').dataset.servings
           
            if(activePrice) {

              if(plan.parentNode.classList.contains('is-double')) {
                totalServings = totalServings * 2
              } 

              if (atcPrice) {
                atcPrice.textContent = activePrice.textContent
              }
              if (savings) {
                savings.textContent = _calculateDifference(originalPrice.textContent, activePrice.textContent)
              }
              if (perServing) {
                perServing.textContent = _calculatePerServing(activePrice.textContent, totalServings)
              }
            } else {
              if (atcPrice) {
                atcPrice.textContent = active.querySelector('.sr-sp-pricing').textContent
              }
              if (savings) {
                savings.textContent = `$0.00`
              }
              if (perServing) {
                perServing.textContent = _calculatePerServing(active.querySelector('.sr-sp-pricing').textContent, totalServings)
              }
            }
         
          }, 250)
        })
      })

      plans.forEach((plan) => {
        plan.addEventListener('click', () => {

          const activePrice = plan.querySelector('.sr-full-price')
          const originalprice = plan.querySelector('.sr-compare-price') || activePrice
          const perServing = plan.querySelector('.num-servings')
          let totalServings = Number(document.querySelector('.sr-variant-select-tab.is-selected').dataset.servings)

          if(activePrice) {

            if(plan.parentNode.classList.contains('is-double')) {
              totalServings = totalServings * 2
            } 

            // sub price
            if (atcPrice) {
              atcPrice.textContent = activePrice.textContent
            }
            if (savings) {
              savings.textContent = _calculateDifference(originalprice.textContent,activePrice.textContent)
            }
            if (perServing) {
              perServing.textContent = _calculatePerServing(activePrice.textContent, totalServings)
            }
          } else {  
            // otp price
            if (atcPrice) {
              atcPrice.textContent = plan.querySelector('.sr-sp-pricing').textContent
            }
            if (savings) {
              savings.textContent = `$0.00`
            }
            if (perServing) {
              perServing.textContent = _calculatePerServing(plan.querySelector('.sr-sp-pricing').textContent, totalServings)
            }
          }
        })
      })

      // for initial load
      function _getCurrentPriceAndSetATC() {
        const sp = document.querySelector('.rtx-subscription-label.is-selected')?.querySelector('.sr-full-price')
        if (atcPrice && sp) {
          atcPrice.textContent = sp.textContent 
        }
      }

      function _calculateDifference(p1,p2){
        const stripped1 = Number(p1.replace('$',''))
        const stripped2 = Number(p2.replace('$',''))
        const dif =  stripped1 - stripped2
        return `${new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(dif).replace('.00', '')}`
      }

      function _calculatePerServing(price, servings) {
        // hide pricing container
        if(!price || !servings) return 

        const stripped = Number(price.replace('$',''))
        const per = stripped / Number(servings)
        return `${new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(per).replace('.00', '')}`
      }

      _getCurrentPriceAndSetATC()
      if (savings) {
        savings.textContent = _calculateDifference(document.querySelector('.rtx-subscription-label.is-selected').querySelector('.sr-compare-price').textContent, document.querySelector('.rtx-subscription-label.is-selected').querySelector('.sr-full-price').textContent)
      }


      const productSection = document.querySelector('.js-buybox-modal')
      const hiddenInput = productSection.querySelector('input[name="id"]');
      const variantTabs = productSection.querySelectorAll('.sr-variant-select-tab');
      variantTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const variantId = tab.getAttribute('data-variant-id');
          hiddenInput.value = variantId;
          hiddenInput.dispatchEvent(new Event('change', {bubbles: true}));
          let curLocation = new URL(window.location);
          curLocation.searchParams.set('variant', variantId);
          history.pushState(null, '', curLocation);
          const tabSiblings = [...tab.parentNode.childNodes].filter(c=>c.nodeType == 1 && c!= tab);
          tabSiblings.forEach((sibling) => {
            sibling.classList.remove('is-selected');
          });
          tab.classList.add('is-selected');
          const featuredMediaId = tab.getAttribute('data-variant-media-id');
          if (featuredMediaId) {
            const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-{{ section.id }}"]`);
            mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`{{ section.id }}-${featuredMediaId}`, true));
          }

          console.log(`Tab changed to variant ID: ${variantId}`);

          // variant specific subscription value props here 
          const productWrapper = tab.closest('.product__info-wrapper');
          if (productWrapper) {
            const subLabels = productWrapper.querySelectorAll('.rtx-subscription-label');
            subLabels.forEach((label) => {
              const productValueProps = label.querySelector('[sr-sp-value-props-product]');
              const variantValueProps = label.querySelectorAll('[sr-sp-value-props-variant]');
              const currentVariantValueProps = label.querySelector(`[sr-sp-value-props-variant="${variantId}"]`);
              if (currentVariantValueProps) {
                variantValueProps.forEach((valueProps) => {
                  valueProps.classList.remove('is--active');
                });
                if (productValueProps) {
                  productValueProps.classList.remove('is--active');
                }
                currentVariantValueProps.classList.add('is--active');
              } else {
                variantValueProps.forEach((valueProps) => {
                  valueProps.classList.remove('is--active');
                });
                if (productValueProps) {
                  productValueProps.classList.add('is--active');
                }
              }
            });
          }
        });
      });
  }

  /**
   * Updates the target DOM element with the content of the new element
   */
  updateDOMElement(targetElement, newElement) {
    if (newElement) {
      targetElement.innerHTML = "";
      targetElement.insertAdjacentHTML("afterbegin", newElement.innerHTML);
    }
  }

  /**
   * Initializes event listeners for the select dropdown.
   * If required elements are missing, the initialization is skipped.
   */
  initCustomDropdown() {
    this.selectBoxes.forEach((selectBox) => {
      const selectPlaceholder = selectBox.querySelector('.js-custom-select-placeholder');
      const selectButton = selectBox.querySelector('.js-custom-select-button');
      const optionsList = selectBox.querySelector('.js-custom-select-options');
      const options = selectBox.querySelectorAll('.js-custom-select-option');
      
      if (!selectBox || !optionsList) return;

      // Set the default selected option if a checkbox is already checked
      this.setDefaultSelectedOption(selectBox, selectPlaceholder);
      
      selectBox.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleDropdown(optionsList, selectButton);
      });

      options.forEach((option) => {
        option.addEventListener('click', (e) => {
          e.stopPropagation();
          this.selectOption(e.currentTarget, selectBox, options, selectPlaceholder, selectButton, optionsList);
        });
      });

      document.addEventListener('click', (e) => {
        if (!selectBox.contains(e.target)) this.closeDropdown(optionsList, selectButton);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeDropdown(optionsList, selectButton);
      });
    });
  }

  /**
   * Set the default selected option if a checkbox is already checked.
   */
  setDefaultSelectedOption(selectBox, selectPlaceholder) {
    const checkedOption = selectBox.querySelector('.js-custom-select-input:checked');
    if (checkedOption) {
      const checkedOptionElement = checkedOption.closest('.js-custom-select-option');
      const selectedOptionName = checkedOptionElement.querySelector('.product-card-wrapper__custom-select').innerHTML;
      this.updatePlaceholder(selectPlaceholder, selectedOptionName);
      this.updateVariantId(checkedOptionElement);
    }
  }

  /**
   * Toggles the dropdown menu visibility.
   */
  toggleDropdown(optionsList, selectButton) {
    optionsList.classList.toggle('active');
    selectButton.classList.toggle('active');
  }

  /**
   * Handles the selection of an option from the dropdown.
   * Updates the placeholder text, clones content to the placeholder, and closes the dropdown.
   *
   * @param {HTMLElement} option - The selected dropdown option.
   */
  selectOption(option, selectBox, options, selectPlaceholder, selectButton, optionsList) {
    const allCheckboxes = selectBox.querySelectorAll('.js-custom-select-input');
    allCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // Check the selected option's checkbox
    const selectedCheckbox = option.querySelector('.js-custom-select-input');
    selectedCheckbox.checked = true;

    // Clone the content of the selected option and update the placeholder
    const selectedOptionName = option.querySelector('.product-card-wrapper__custom-select').innerHTML;
    this.updatePlaceholder(selectPlaceholder, selectedOptionName);

    // Close the dropdown and update active state
    this.closeDropdown(optionsList, selectButton);
    options.forEach((opt) => opt.classList.remove('active'));
    option.classList.add('active');
    this.updateVariantId(option);
  }

  updateVariantId(option) {
    const formElement = option.closest('form');
    formElement.querySelector('[name="id"]').value = option.dataset.variantId;
    formElement.querySelector('[name="selling_plan"]').value = option.dataset.sellingPlanId;
  }

  /**
   * Closes the dropdown menu and removes active classes.
   */
  closeDropdown(optionsList, selectButton) {
    optionsList.classList.remove('active');
    selectButton.classList.remove('active');
  }

  /**
   * Update the dropdown menu placeholder.
   */
  updatePlaceholder(selectPlaceholder, selectedValue) {
    selectPlaceholder.innerHTML = selectedValue;
  }
}

if(!customElements.get("lsg-product-grid")) {
    customElements.define("lsg-product-grid", LSGProductGrid);
}
